import { ProjectId, AssetId, snapToGrid, getAsset } from 'owa-timestream-store';
import getStore from '../store';

export default function getAssetViewPositionStyle(
    projectId: ProjectId,
    assetId: AssetId,
    isSelected: boolean
) {
    const { bounds } = getAsset(projectId, assetId)!;

    const store = getStore();
    const offset = isSelected ? store.assetOffset : null;
    const { x, y, width, height } = bounds;
    const isDragging = !!offset && store.hasDraggedFarEnough;

    // PERF: only read zoom if we're going to use it, so we don't re-render assets during zoom operations.
    const { dx, dy } = offset || { dx: 0, dy: 0 };
    const zoom = isDragging ? store.zoom : 1;

    return {
        top: snapToGridWhenDragging(isDragging, y, dy / zoom),
        left: snapToGridWhenDragging(isDragging, x, dx / zoom),
        width: width == 0 ? undefined : width,
        height: height == 0 ? undefined : height,
    };
}

function snapToGridWhenDragging(isDragging: boolean, position: number, delta: number) {
    // When we're not dragging the asset we'll draw the asset in its original position
    // so we preserve the layout that assets had before we added snapToGrid.
    // But once we start moving we will do snapToGrid when we stop
    // in the same position where the asset is going to land.
    return isDragging ? snapToGrid(position + delta) : position;
}
